import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import LandingPage from './components/landing/LandingPage';
import InfoPage from './components/info/InfoPage';
import VerifyEmailPage from './components/auth/VerifyEmailPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import './App.css';

/**
 * Strona kliencka jest wizytówką aplikacji mobilnej, nie aplikacją webową.
 *
 * Nie ma tu logowania ani rejestracji: konto zakłada się i obsługuje w aplikacji
 * na telefon. Zostają tylko landing, dokumenty (kontakt, FAQ, regulamin,
 * prywatność) oraz dwa ekrany, do których prowadzą linki z e-maili:
 * potwierdzenie adresu i ustawienie nowego hasła. Reszta adresów wraca na "/".
 */
function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/info" element={<InfoPage />} />
      {/* Czytelny adres wsparcia (support URL dla App Store / Apple Developer) */}
      <Route path="/kontakt" element={<Navigate to="/info?tab=kontakt" replace />} />
      {/* Cele linków z e-maili wysyłanych przez backend */}
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
